export class FilterableList extends HTMLElement {
  constructor() {
    super();

    this.filterSelector = this.getAttribute("filter-selector");
    this.resultListSelector = this.getAttribute("result-list-selector");
    this.resultDataField = this.getAttribute("result-data-field");

    if (!this.filterSelector) {
      throw new Error(
        "No filter-selector attribute found on <filterable-list> element.",
      );
    }
    if (!this.resultListSelector) {
      throw new Error(
        "No result-list-selector attribute found on <filterable-list> element.",
      );
    }
    if (!this.resultDataField) {
      throw new Error(
        "No result-data-field attribute found on <filterable-list> element.",
      );
    }
  }

  connectedCallback() {
    this.elements = {
      filters: this.querySelectorAll(this.filterSelector),
      resultLists: this.querySelectorAll(this.resultListSelector),
    };

    this.elements.filters.forEach((filter) => {
      filter.addEventListener("input", this.filterChanged);
    });
  }

  disconnectedCallback() {
    this.elements.filters.forEach((filter) => {
      filter.removeEventListener("input", this.filterChanged);
    });
  }

  filterChanged = (e) => {
    e.preventDefault();

    if (this.timeout) {
      clearTimeout(this.timeout);
      delete this.timeout;
    }

    // use setTimeout to debounce changes
    this.timeout = setTimeout(() => {
      delete this.timeout;
      this._filterChanged(e.target);
    }, 200);
  };

  _filterChanged(el) {
    const re = new RegExp(`${el.value}`, "i");

    this.elements.resultLists.forEach((resultList) => {
      for (let idx = 0; idx < resultList.children.length; idx++) {
        const child = resultList.children[idx],
          data = child.dataset[this.resultDataField],
          isMatch = re.test(data);

        child.classList.toggle("pv-hide", !isMatch);
      }
    });
  }
}

customElements.define("filterable-list", FilterableList);
